import { axios, base } from '../http';

export const getCommCallRecordListPage = (params) => axios.get(`${base}/api/CommCallRecord/GetListPage`, { params });

export const exportCommCallRecords = (params) => axios.get(`${base}/api/CommCallRecord/Export`, { params, responseType: "blob" });

// ---- ScreenDevice ----
